import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { EndpointList } from '../endpoint-list';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private user: User;

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
  ) {
    this.user = new User(null);
  }

  setUser(): void {
    const token: string = localStorage.getItem('token') || '';
    const decodedToken = this.jwtHelper.decodeToken(token);
    this.user = new User(decodedToken);
  }

  getUser(): User {
    if (!this.user || !this.user.email) {
      this.setUser();
    }
    return this.user;
  }

  me(): Observable<User> {
    return this.http.get<User>(EndpointList.me());
  }

  getUsers(): Observable<any> {
    return this.http.get<User[]>(EndpointList.users());
  }

  getUserById(id: number): Observable<User> {
    return this.http.get<User>(EndpointList.users(id));
  }

  createUser(user: User): Observable<any> {
    return this.http.post<any>(EndpointList.users(), user);
  }

  deleteUser(userId: number): Observable<any> {
    return this.http.delete(EndpointList.users(userId));
  }

  deleteMyUser(): Observable<any> {
    return this.http.delete(EndpointList.meDelete());
  }

  getUserProfile(): Observable<any> {
    return this.http.get<User>(EndpointList.userProfile());
  }

  updateUserProfile(userData: FormData): Observable<User> {
    return this.http.put<User>(EndpointList.userProfile(), userData);
  }
}